// extracted by mini-css-extract-plugin
export default {"container":"ListItem_container__rEOuE","avatar":"ListItem_avatar__Q3JhV","infoWrapper":"ListItem_infoWrapper__FcE4g"};